export type EmailLog = {
  to: string;
  title: string;
  content: string;
  userId: string;
  status: number;
  createdAt: string;
};

export interface EmailLogsMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  getEmailLogs(
    page: number,
    limit: number,
    startDate: Date,
    endDate: Date,
    field?: string | undefined,
    searchTerm?: string | undefined,
    orderField?: string,
    asc?: boolean
  ): Promise<{
    emailLogs: EmailLog[];
    meta: {
      currentPage: number;
      totalPages: number;
      totalCount: number;
    };
  }>;
}
export const EmailLogsMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async getEmailLogs(
    page: number,
    limit: number,
    startDate: Date,
    endDate: Date,
    field?: string | undefined,
    searchTerm?: string | undefined,
    orderField?: string,
    asc?: boolean
  ): Promise<{
    emailLogs: EmailLog[];
    meta: {
      currentPage: number;
      totalPages: number;
      totalCount: number;
    };
  }> {
    const res = await this.fetch(
      `/email_logs?page=${page}&limit=${limit}&start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}` +
        (field ? `&field=${field}` : '') +
        (searchTerm ? `&search_term=${searchTerm}` : '') +
        (orderField ? `&order_field=${orderField}` : '') +
        (asc ? `&order_dir=asc` : `&order_dir=desc`)
    );
    return res;
  },
} as EmailLogsMixin;
